module.exports = __webpack_public_path__ + "static/media/Search_Gray.21c2dba8.svg";